import curry from 'transmute/curry';
export const buildReplyId = curry((replyNamespace, threadSource, threadId) => `${threadSource}_${replyNamespace}_${threadId}`);